!
<template>
  <div style="overflow: hidden">
    <el-top-nav-menu-4
      :companyTitle="$t('subcontractor.menuTitle')"
      :showInput="false"
      :Menu4Href="Menu4Href"
      ref="topNavMenu"
      :logo="LOGO"
      width="1180px"
      padding="0"
      :showHelp="showHelp"
    >
      <!-- <div class="ldg" @click="goser">
        <span class="dpng">{{ $t("page.applyUsername.btn.msg10") }}</span>
        <div class="los">
          <img :src="leftgg" />
        </div>
      </div> -->
    </el-top-nav-menu-4>

    <div class="ready-data business-open-content">
      <div style="height: 15px"></div>
      <div class="ready-data-content">
        <div style="clear: both" class="box">
          <!-- <div
            class="phy"
            style="margin-right: 25px; margin-left: 65px"
            @click="outPage(subUrl)"
          >
            <span class="topTriangle"></span>
            <div class="titleStyle titleFonts">分包商注册</div>
            <span class="buttomTriangle"></span>
            <div class="information">
              <p v-for="(item, index) in infor1" :key="index">
                {{ item }}
              </p> -->
          <!-- <el-button  @click="outPage(subUrl)">分包商注册</el-button> -->
          <!-- <p>
                7、法人店铺授权委托书&nbsp;<span style="font-size: 13px; color: #9b9b9b">请下载</span><a target="_blank"
                  :href="downFileUrl1" download="授权委托书模板.doc" style="color: #0089ef; font-size: 13px">授权委托书模板</a>
              </p> -->
          <!-- </div>
          </div> -->
          <!--        <div class="phy" style="margin-left: 25px" @click="goPage()">
          <span class="topTriangle"></span>
          <div class="titleStyle titleFonts">供应方注册</div>
          <span class="buttomTriangle"></span>
          <div class="information">
            <p v-for="(item, index) in infor2" :key="index">{{ item }}</p>
            &lt;!&ndash; <el-button  @click="goPage()">供应商注册</el-button> &ndash;&gt;
            &lt;!&ndash; <p>
              8、法人店铺授权委托书&nbsp;<span style="font-size: 13px; color: #9b9b9b">请下载</span><a target="_blank"
                :href="downFileUrl1" download="授权委托书模板.doc" style="color: #0089ef; font-size: 13px">授权委托书模板</a>
            </p> &ndash;&gt;
          </div>
        </div>-->
          <div class="card">
            <div
              class="card-item"
              v-for="(card, index) in cardList"
              :key="card.flag"
            >
              <div class="card-header">
                <div class="card-icon">
                  <div :class="['flag', card.flagClass]">
                    {{ card.flagText }}
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="card-title">{{ card.title }}</div>
                <div class="card-desc" v-html="card.desc"></div>
                <div class="card-btn" @click="outPage(index)">{{ $t('subcontractor.registrationButton') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="goToShop">
        <div class="goToShopDetails"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { addUrlPerFix } from "@/utils";
export default {
  name: "transferPage",
  data() {
    return {
      showHelp: false,
      LOGO: require("@/assets/images/jrzl.png"),
      leftgg: require("@/assets/images/llop.png"),
      Menu4Href: true,
      shopPage: addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL),
      subUrl: this.$addUrlPerFix(process.env.VUE_APP_SUBPAGE_URL),
      downFileUrl1: this.$addUrlPerFix(process.env.VUE_APP_FILE_URL_FILE),
      //   shopagreement: false,
      //   shopagreements: shopagreements,
      infor1: [
        "1、企业营业执照副本复印件（三证合一，需完成有效年检且所售商品属于经营范围内）",
        "2、资质证书附件",
        "3、设备附件",
        "4、法人代表人身份证正反面",
        "5、安全许可证书附件",
        "6、法人代表授权委托书附件"
      ],
      infor2: [
        "1、企业营业执照副本复印件（三证合一，需完成有效年检且所售商品属于经营范围内）",
        "2、法人代表人身份证正反面",
        "3、法人代表授权委托书附件"
      ],
      cardList: [
        {
          flag: "domestic",
          flagText: "境内",
          flagClass: "flag-domestic",
          title: this.$t('subcontractor.domestic'),
          desc: `${this.$t('subcontractor.tipsTop')}<br />${this.$t('subcontractor.tipsBottom')}`
        },
        {
          flag: "overseas",
          flagText: "境外",
          flagClass: "flag-overseas",
          title: this.$t('subcontractor.overseas'),
          desc: `${this.$t('subcontractor.tipsTop')}<br />${this.$t('subcontractor.tipsBottom')}`
        }
      ],
      checked: false
    };
  },
  mounted() {
    this.$store.commit("RELOAD_SET", false);
  },
  methods: {
    down() {
      console.log("fdsfds");
    },
    goser() {
      this.$router.push({
        path: "/regView/mobileValidate"
      });
    },
    nextStepClick() {
      this.$store.commit("DEL_CACHED_VIEW", {
        name: "applyShopInfo"
      });
      this.$store.commit("DEL_CACHED_VIEW", {
        name: "inputBusinessInfo"
      });
      this.$store.dispatch("businessOpenShopSetStep", 2);
      this.$router.replace("/business-open-shop/register");
    },
    shopagreementHand() {
      this.shopagreement = true;
    },
    handleClose(done) {
      done();
    },
    outPage(ingdex) {
      // 境内分包商注册
      if (ingdex == 0) {
        window.open(this.subUrl + '?type=domestic');
      }
      // 境外分包商注册
      if (ingdex == 1) {
        window.open(this.subUrl + '?type=overseas');
      }
    },
    goPage() {
      this.$router.push("/supplier-registration");
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/
  .el-top-nav-menu4
  .sub-menu-wrapper-wrapper
  .sub-menu-wrapper
  .logo-container
  img {
  display: inline-block;
  vertical-align: middle;

  border: none;
}

.ready-data {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  min-height: calc(100vh - 285px) !important;
  height: auto !important;

  .goToShop {
    width: 1180px;
    height: 18px;
    margin-bottom: 20px;
    font-family: PingFang-SC-Medium;
    font-size: 13px;
    color: #9b9b9b;
    line-height: 18px;

    .goToShopDetails {
      width: 290px;
      height: 100%;
      margin: 0 auto;
      text-align: center;
    }

    .shopagreementcss {
      color: #f50b25;
      cursor: pointer;
    }
  }
}
// .ready-data-content .phy:nth-child(1){
//       margin-left: 330px !important;

// }
.ready-data-content {
  width: 100%;
  min-height: 245px;
  margin-top: 30px;

  .phy {
    // float: left;
    margin-top: 30px;
    width: 500px;
    height: 500px;
    background-color: #fff;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.23);
    float: left;

    .information {
      //width: 460px;
      height: 357px;
      margin-top: 20px;
      margin-left: 20px;
      overflow-y: auto;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #4a4a4a;
      padding: 0 20px;

      p {
        margin: 16px 0px;
      }
    }

    .titleStyle {
      width: 160px;
      height: 40px;
      background: #ff262b;
      border-radius: 0 18.5px 18.5px 0;
      border-radius: 0px 18.5px 18.5px 0px;
      margin-left: -9px;
    }

    .titleFonts {
      font-family: PingFangSC-Regular;
      font-size: 22px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }

    .topTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      margin-top: 11px;
      border-bottom: 9px solid brown;
      border-left: 9px solid transparent;
    }

    .buttomTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      border-top: 9px solid brown;
      border-left: 9px solid transparent;
    }
  }

  .phy1 {
    //margin-top: 30px;
    width: 500px;
    height: 500px;
    background-color: #fff;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.23);
    float: left;

    .information {
      //width: 460px;
      height: 357px;
      margin-top: 20px;
      margin-left: 20px;
      overflow-y: auto;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #4a4a4a;
      padding: 0 20px;

      p {
        margin: 16px 0px;
      }
    }

    .titleStyle {
      width: 160px;
      height: 40px;
      background: #ff262b;
      border-radius: 0 18.5px 18.5px 0;
      border-radius: 0px 18.5px 18.5px 0px;
      margin-left: -9px;
    }

    .titleFonts {
      font-family: PingFangSC-Regular;
      font-size: 22px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }

    .topTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      margin-top: 11px;
      border-bottom: 9px solid brown;
      border-left: 9px solid transparent;
    }

    .buttomTriangle {
      display: block;
      width: 0px;
      height: 0px;
      margin-left: -9px;
      border-top: 9px solid brown;
      border-left: 9px solid transparent;
    }
  }

  > span {
    font-size: 36px;
    font-weight: 400;
    color: #999999;
  }
}

.business-open-content {
  margin-top: 20px 10px;
}

.agreementModalCss {
  color: #666666;
  font-size: 13px;
  padding: 0 50px;
  height: 530px;
  overflow-y: auto;

  /deep/ .title {
    display: block;
    text-align: center;
    margin-top: 5px;
    margin-bottom: 10px;
    font-weight: 600;
  }

  /deep/ div:nth-of-type(1) {
    margin-bottom: 20px;
  }

  /deep/ div:nth-of-type(2) {
    div {
      margin-top: 10px;
      margin-bottom: 5px;
    }

    span {
      display: block;
    }
  }
}

/deep/ .title {
  display: block;
  text-align: center;
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 600;
  font-family: 微软雅黑;
  color: #212121;
}

/deep/ .remind {
  isplay: block;
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 600;
  font-family: 微软雅黑;
  color: red;
}

/deep/ .titleInfor {
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 600;
  font-family: 微软雅黑;
  color: #212121;
}

/deep/ .el-checkbox {
  margin-right: 5px;
}

/deep/ .infrobottom {
  margin-bottom: 20px;
}

.box {
  width: 1180px;
  margin: 0 auto;
}
.regUpload {
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-radius: 4px;
  position: absolute;
  top: 228px;
  left: 340px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  cursor: pointer;
}
.countDown {
  width: 110px;
  height: 40px;
  /* background: rgba(242, 242, 242, 1); */
  background-color: #ff142f;
  border-radius: 4px;
  border: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #fff;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  margin-left: 10px;
}

.testNumber {
  width: 500px;
  height: 40px;
  background: #ff142f;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  cursor: pointer;
  text-align: center;
  line-height: 40px;
}

.codeList li {
  width: 100%;
  height: 100%;
  line-height: 30px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  /* line-height: 18px; */
}

.card {
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 30px;
  width: 100%;
  padding: 20px 0;
}

.card-item {
  width: 300px;
  min-height: 390px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e9ebf0;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 30px 32px;
  box-sizing: border-box;
  cursor: pointer;
}

.card-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.1);
}

.card-header {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 28px;
}

.card-icon {
  width: 108px;
  height: 108px;
  border-radius: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.23);
}

.flag {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
}

.flag-domestic {
  background: linear-gradient(135deg, #ff4d4f 0%, #de241c 100%);
}

.flag-overseas {
  background: linear-gradient(135deg, #5aa7ff 0%, #2a7fff 100%);
}

.card-body {
  width: 100%;
  text-align: center;
}

.card-title {
  font-size: 26px;
  line-height: 1.2;
  color: #222222;
  font-weight: 700;
  margin-bottom: 14px;
}

.card-desc {
  font-size: 16px;
  line-height: 1.8;
  color: #8f8f8f;
  margin-bottom: 34px;
}

.card-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  min-width: 148px;
  padding: 0 24px;
  color: #ff142f;
  border: 1px solid #ff142f;
  border-radius: 21px;
  font-size: 16px;
  font-weight: 600;
  background: transparent;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.card-btn:hover {
  background: rgba(255, 20, 47, 0.08);
}
</style>
